import { render, staticRenderFns } from "./ScreenNavigation.vue?vue&type=template&id=2a47dff6&scoped=true"
import script from "./ScreenNavigation.vue?vue&type=script&lang=js"
export * from "./ScreenNavigation.vue?vue&type=script&lang=js"
import style0 from "./ScreenNavigation.vue?vue&type=style&index=0&id=2a47dff6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a47dff6",
  null
  
)

export default component.exports